import { render, staticRenderFns } from "./navgiation.vue?vue&type=template&id=98dae9fa&"
import script from "./navgiation.vue?vue&type=script&lang=js&"
export * from "./navgiation.vue?vue&type=script&lang=js&"
import style0 from "./navgiation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports